
/* ============================== src/components/views/CabinetView.jsx ============================== */
// src/components/views/CabinetView.jsx
/**
 * Обёртка над Cabinet: подписывается на срез кабинета и прокидывает
 * данные в чистый презентационный Cabinet.
 *
 * `openEmployeeTasks` больше не передаётся: вкладка «Загрузка», которая
 * его использовала, перенесена в раздел «Персонал» (StaffView).
 *
 * `store` не передаётся (legacy после DataStore, попутки Шага 10):
 * Cabinet работает через React Query-хуки, DataStore удалён.
 */
import { memo } from "react";
import Cabinet from "../Cabinet";
import { useCabinetDb } from "../../hooks/useDb";

function CabinetView({
  user,
  openTask,
  openProject,
  openVacation,
  openDelegation,
}) {
  const data = useCabinetDb();
  return (
    <Cabinet
      data={data}
      user={user}
      openTask={openTask}
      openProject={openProject}
      openVacation={openVacation}
      openDelegation={openDelegation}
    />
  );
}

export default memo(CabinetView);
